import { render, staticRenderFns } from "./IssueListv2.vue?vue&type=template&id=6d5b75f4&"
import script from "./IssueListv2.vue?vue&type=script&lang=ts&"
export * from "./IssueListv2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports